// import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';
import { VF_SUB_SECTION_TITLE1 } from 'AppSrc/core/components/forms/form-base-components/v-f-section-header';


const fieldId = 'Scheduled-window-title';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Scheduled Change Window',
};

const ScheduledTitle = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE1,
};

export { ScheduledTitle };
